module.exports = __webpack_public_path__ + "static/media/funitygame2.0bd099b9.png";